import { useEffect, useRef, useState } from "react";
import ClipboardJS from "clipboard";
import * as Sentry from "@sentry/react";

export default function useCopyToClipboard(activateSelector, id) {
  const clipboardRef = useRef(null);
  const [isCopied, setIsCopied] = useState(false);
  useEffect(() => {
    clipboardRef.current = new ClipboardJS(activateSelector);

    clipboardRef.current.on("success", function (e) {
      if (`#${id}` === e.trigger.getAttribute("data-clipboard-target")) {
        setIsCopied(true);
      }
      e.clearSelection();
      setTimeout(() => {
        setIsCopied(false);
      }, 2000);
    });

    clipboardRef.current.on("error", function (e) {
      Sentry.captureException(e, {
        tags: {
          component: "useCopyToClipboard",
        },
        level: "warning",
      });
    });
    return () => {
      setIsCopied(null);
    };
  }, [activateSelector]);
  return {
    isCopied,
  };
}
